
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component
export default class CPFundSummary extends Vue {

  public get fundInformation() {
    return this.$store.state.fundSummaryModal.details;
  }

  public colours = [
    '#1F2041',
    '#D0D6B5',
    '#FFC857',
    '#987284',
    '#119DA4',
    '#4B3F72',
    '#19647E',
    '#75B9BE',
    '#EAF9D9',
    '#F9B5AC',
    '#EE7674',
    '#CCC7B9',
    '#AF7A6D',
    '#653239',
    '#62929E',
  ];

  public truncateText(text: string, truncateLength: number) {
    return text.length > truncateLength ? text.substring(0, truncateLength) + '...' : text;
  }

}
